<template>
  <popper
    trigger="hover"
    class="keyboard-tips"
    :append-to-body="true"
    :options="{
      placement: 'top',
      modifiers: { offset: { offset: '-95px,0px' } },
      preventOverflow: { padding: '0px' },
    }"
  >
    <keyboard-popup class="popper" />
    <div slot="reference" class="-label wt2-color-link">Keyboard Tips</div>
  </popper>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import KeyboardPopup from './KeyboardPopup.vue';

export default {
  name: 'keyboard-tips',
  components: {
    Popper,
    KeyboardPopup,
  },
};
</script>

<style lang="scss" scoped>
.keyboard-tips {
  position: absolute;
  right: 0;
  top: -53px;
  cursor: pointer;
  font-size: 14px;
}
</style>
